import domain from '../domain';

const onPolygonButtonClick = domain.event<'edit' | 'done' | 'del'>();

export default onPolygonButtonClick;
